export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const GOOGLE_CLIENT_ID =
  "879752203865-kpc52vlmopu7s4b4u7gjn28clc8334ta.apps.googleusercontent.com";
export const GOOGLE_SECRET_KEY = "AIzaSyAfUrJ5li3jjQEdLznTrB9LiwRBcaW7MV8";
export const SCOPE_APIS = "https://www.googleapis.com/auth/drive";
